import moment from 'moment'
export default {
  "entityName": "disposed",
  upsert: 'full',
  filterStorage: {},
  "pagination": {
    "rowsPerPage": 10,
    "page": 1,
    "sortBy": "id",
    "descending": true
  },
  "fields": [
    {
      text: 'Insert Date',
      value: 'date',
      render: item => moment(item.date).format('YYYY-MM-DD'),
      table: {
        filter: true
      },
      //issue 316 - modifica date da-a , aggiunto placeholderx
      filtertofrom: true,
      'type': 'date', //issue 257 services cambiato datetime con date
      //visible: false,
      //issue 316 - modifica date da-a , aggiunto placeholderx
      readonly: true,
    },
     {
      text: 'Requested Date',
      value: 'status_requested_date',
      render: item => item.status_requested_date ? moment(item.status_requested_date).format('YYYY-MM-DD'):null,
      filtertofrom: true,
      'type': 'datetime',
      readonly: (item,state)=>  !(state.user.role === 'Administrator' || state.user.role === 'EMN User'),
      visible: (item,state)=>  (state.user.role === 'Administrator' || state.user.role === 'EMN User') && (item.status === 'REQUESTED' || item.status === 'CANCELED' || item.status === 'DOCUMENTED' || item.status === 'VALIDATED'  || item.status === 'IMPORTED'),
      validators: [
          (field, value, item) => {
            if (!item.canceling && !value) {
              return 'Requested Date is required'
            }
            return true
          },
      ]
    },
    {
      text: 'Documented Date',
      value: 'status_documented_date',
      render: item => item.status_documented_date ? moment(item.status_documented_date).format('YYYY-MM-DD'):null,
      filtertofrom: true,
      'type': 'datetime',
      readonly: (item,state)=>  !(state.user.role === 'Administrator' || state.user.role === 'EMN User'),
      visible: (item,state)=>(state.user.role === 'Administrator' || state.user.role === 'EMN User') && (item.status === 'DOCUMENTED' || item.status === 'CANCELED' || item.status === 'VALIDATED'  || item.status === 'IMPORTED'),
      validators: [
          (field, value, item) => {
            if (!item.canceling && !value) {
              return 'Documented Date is required'
            }
            return true
          },
      ]
    },
     {
      text: 'Canceled Date',
      value: 'status_canceled_date',
      render: item => item.status_canceled_date ? moment(item.status_canceled_date).format('YYYY-MM-DD'):null,
      filtertofrom: true,
      'type': 'datetime',
      readonly: (item,state)=>  !(state.user.role === 'Administrator' || state.user.role === 'EMN User'),
      visible: (item,state)=> (state.user.role === 'Administrator' || state.user.role === 'EMN User') && (item.status === 'CANCELED'  || item.status === 'IMPORTED'),
      validators: [
          (field, value, item) => {
            if (!item.canceling && !value) {
              return 'Canceled Date is required'
            }
            return true
          },
      ]
    },
    {
      text: 'Validated Date',
      value: 'status_validated_date',
      render: item => item.status_validated_date ? moment(item.status_validated_date).format('YYYY-MM-DD'):null,
      filtertofrom: true,
      'type': 'datetime',
      readonly: (item,state)=>  !(state.user.role === 'Administrator' || state.user.role === 'EMN User'),
      visible: (item,state)=>  (state.user.role === 'Administrator' || state.user.role === 'EMN User') && (item.status === 'VALIDATED'  || item.status === 'IMPORTED'),
      validators: [
          (field, value, item) => {
            if (!item.canceling && !value) {
              return 'Validated Date is required'
            }
            return true
          },
      ]
    },
    {
      "value": "protocol_id",
      "text": "Protocol",
      "type": "autocomplete",
      readonly: true,
      "table": {
        "sortable": true,
        filter: true
      },
      "title": "name",
      "subtitle": "name",
      visible: false,
    },
    {
      value: 'site.city',
      text: 'Where',
      readonly: true,
      filter: (item, search) => {
        if (search) return [
          { 'site.name': `%${search}%`}, { 'site.city': `%${search}%`}, { 'site.code': `%${search}%`},
          { 'site.id': null, 'storage.name': `%${search}%`},
          { 'disposal.name': `%${search}%` }]
      },            
      table: {
        sortable: true,
        filter: true
      },
      title: 'name',
      render: (item) => (item.site && item.site.id && `${item.site.city} - ${item.site.name}`) || item.storage && item.storage.name || item.disposal && item.disposal.name,
      // visible: item => item.site_id
    },
    {
      value: '_pdf',
      text: 'Destroy documentation',
      type: 'file',
      visible: (item, state) => item.status !== 'CANCELED' && (!['VALIDATED', 'DOCUMENTED'].includes(item.status) || state.user.role === 'Administrator' || state.user.role === 'EMN User' || state.user.role === 'Monitor'),
      validators: [
        (field, value,item) => {
          if (item.status === 'REQUESTED')
          {
            return (value) || 'Destroy documentation is required'
          }
          else
          {
            return true
          }
        }
      ]
    },
    {
      full: true,
      value: 'note',
      text: 'Reasons for destroy',
      type: 'textarea',
      readonly: true,
      visible: item => item.note
    },        
    {
      value: 'status',
      text: 'Status',
      type: 'list',
      list: ['INIT', 'REQUESTED', 'IMPORTED', 'DOCUMENTED', 'VALIDATED'],
      table: {
        sortable: true,
        filter: true
      },
      visible: false
    },
		{
			value: 'disposed_drugs.name',
			text: 'Drugs',
			id: 'id',
			filter: (item, search) => search && [{ 'disposed_drugs.name': `%${search}%` }],
			subtitle: item => `${item.dose}${item.measure_unit} - ${item.protocol.name}`,
			type: 'autocomplete',
			table: {
					filter: true,
			},
			render: item => 
					{ 
            return item.disposed_drugs.reduce((drugs, drug) => { 
              let n_pieces=0
              let n_partially=0
              item.drugs.forEach(element => {
                if(drug.id===element.drug_id){
                  n_pieces+=element.n_pieces
                  n_partially+=element.n_partially
              }
              });
              return drugs + `${drug.name}(${drug.dose + drug.measure_unit}, ${(n_pieces + '/' + Number(n_partially))}) `
            } , '') 
          },
			visible: false
		}
  ],
  "actions": [
    "upsert",
    "audit"
  ]
}
